import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 16v-8l-2 2","key":"svg-0"}],["path",{"d":"M13 16l4 -4","key":"svg-1"}],["path",{"d":"M17 16l-4 -4","key":"svg-2"}]]

/**
 * IconMultiplier1x
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbXVsdGlwbGllci0xeCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOSAxNnYtOGwtMiAyIiAvPgogIDxwYXRoIGQ9Ik0xMyAxNmw0IC00IiAvPgogIDxwYXRoIGQ9Ik0xNyAxNmwtNCAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/multiplier-1x
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMultiplier1x = createReactComponent('outline', 'multiplier-1x', 'Multiplier1x', __iconNode);

export default IconMultiplier1x;